// Order poll modal
$('.JSOrderPoll').click(function() {
	var order_id = $(this).data('id');
	
	$.ajax({
		type: "POST",
		url: base_url + 'poll-content',
		data: { order_id: order_id },
		success: function(response) {
			$('#JSOrderPollContent').html(response);
			$('#JSOrderPollModal').modal('show');
		}
	});
});   